const RutinasData = [
  {
    img: 'https://fullmusculo.com/wp-content/uploads/2023/04/1.png',
    url: 'https://fullmusculo.com/rutina-peso-corporal/'
  },
  {
    img: 'https://fullmusculo.com/wp-content/uploads/2023/04/2.png',
    url: 'https://fullmusculo.com/entrenamiento-bandas-de-resistencia/'
  },
  {
    img: 'https://fullmusculo.com/wp-content/uploads/2023/04/3.png',
    url: 'https://fullmusculo.com/rutina-torso-pierna/'
  },
  {
    img: 'https://fullmusculo.com/wp-content/uploads/2023/04/4.png',
    url: 'https://fullmusculo.com/rutinas/'
  },
];

export default RutinasData;
